import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            精选内容分类
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto leading-relaxed">
            六大领域，全方位覆盖您对优质内容的需求。每个分类都经过精心筛选，为您呈现最有价值的阅读体验。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={'/category/' + cat.slug}
              className="group block bg-background-50 rounded-lg p-5 md:p-6 border border-background-200 hover:border-primary-300 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-100 text-accent-500 mb-4 group-hover:bg-accent-200 transition-colors duration-200">
                <i className={cat.icon + ' text-xl'}></i>
              </div>
              <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors duration-200">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-4">
                {cat.description}
              </p>
              <div className="flex items-center justify-between">
                <span className="text-xs text-foreground-500">{cat.articleCount} 篇文章</span>
                <span className="flex items-center gap-1 text-sm text-primary-500 font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap">
                  浏览分类 <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}